import * as React from "react";

function SvgDatabricks(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 65 65" {...{ ...props, ref }}>
      <g
        id="g50"
        transform="matrix(0.75294118,0,0,0.75294118,1.0541175,18.823529)"
      >
        <path
          fill="#db1905"
          id="path2"
          d="M 0,24.8 V 38.5 L 41.1,60 82.2,38.5 v -13.7 0 L 67.7,17.4 82.2,9.8 v -13.6 0 0 -0.1 L 82.1,-3.8 41.1,-25 0.1,-3.9 H 0 V 9.8 L 14.5,17.4 0,24.8"
        />
        <polygon
          transform="translate(0,-36)"
          fill="#ff5224"
          id="polygon4"
          points="0,60.8 41.1,82.3 82.2,60.8 67.7,53.4 41.1,67.3 14.5,53.4 "
        />
        <polygon
          transform="translate(0,-36)"
          fill="#ff5224"
          id="polygon6"
          points="82.2,32.2 41.1,53.7 0,32.2 41.1,11 "
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgDatabricks);
